import {useCallback} from "react";
import {useTranslation} from "react-i18next";

export const useGeolocation = () => {
    const {t} = useTranslation();

    const getPosition = useCallback(
        (): Promise<GeolocationPosition> =>
            new Promise((resolve, reject) => {
                const tryGetPosition = (retries = 2) => {
                    navigator.geolocation.getCurrentPosition(
                        resolve,
                        (error: GeolocationPositionError) => {
                            if (
                                error.code === error.POSITION_UNAVAILABLE &&
                                retries > 0
                            ) {
                                setTimeout(() => tryGetPosition(retries - 1), 1000);
                                return;
                            }

                            reject(error);
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 15000,
                        }
                    );
                };

                tryGetPosition();
            }),
        []
    );

    const handleGeolocationError = useCallback(
        (error: GeolocationPositionError) => {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    alert(t("constraints.internal.user_blocked_geolocation"));
                    break;

                case error.POSITION_UNAVAILABLE:
                    alert(t("constraints.internal.location_fetching_failed"));
                    break;

                case error.TIMEOUT:
                    alert(t("constraints.internal.location_fetching_failed"));
                    break;

                default:
                    alert(t("constraints.internal.location_fetching_failed"));
            }
        },
        [t]
    );

    return {getPosition, handleGeolocationError};
};